import { render, staticRenderFns } from "./NewbiTask.vue?vue&type=template&id=af4024b0&scoped=true"
import script from "./NewbiTask.vue?vue&type=script&lang=js"
export * from "./NewbiTask.vue?vue&type=script&lang=js"
import style0 from "./NewbiTask.vue?vue&type=style&index=0&id=af4024b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4024b0",
  null
  
)

export default component.exports